import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, FormArray, ValidatorFn, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import * as FilePond from 'filepond';
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
// Register plugins
FilePond.registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);


import { ModifierService } from '@teem/app/core/services/modifier.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ProductForm } from '@teem/core/model-forms/product-form';
import { ProductAddon } from '@teem/app/core/models/product-addon';
import { ProductAddonForm } from '@teem/app/core/model-forms/product-addon-form';
import { ProductService } from '@teem/services/product.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { category, store as StoreApi } from '@teem/constants/api';
import { Product } from '@teem/core/models/product';
import { DEFAULT_LOGO } from '@teem/constants/defaults';
import { Modifier } from '@teem/app/core/model-forms/modifier-model';
import { Select2Directive } from "@teem/directives/select2.directive";
import { SharedModule } from '@teem/app/shared';
import { AddCategoryModalComponent } from '@teem/app/shared/components/add-category-modal/add-category-modal.component';
declare var $;


export const minMaxValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const min = group.get('min')?.value;
  const max = group.get('max')?.value;

  if (min != null && max != null && max < min) {
    return { maxLessThanMin: true };
  }

  return null;
};

export function notAllOptionsSelectedValidator(getOptions: () => any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selected = control.value || [];
    const allOptions = getOptions() || [];

    if (selected.length == allOptions.length && allOptions.length > 0) {
      return { allOptionsSelected: true };
    }

    return null;
  };
}

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent implements OnInit {

  @Input() productInfo;
  @ViewChild('editProductForm') editProductForm: FormGroupDirective;
  @ViewChild(Select2Directive) select2Directive = null;

  productForm: FormGroup;
  submitted: boolean = false;
  productCategoriesApi: string = StoreApi.productCategories;
  isSubmitted = false;
  basicInfo: any;
  productImageUrl: any = "";
  base64LogoString = [];
  logoFile: any = null;
  logoUrl: any = null;
  defaultLogoUrl: string = DEFAULT_LOGO;
  deleteLogo: boolean = false;
  modifiers: Modifier[] = [];
  storeFrontBranchApi: string = StoreApi.branchesInfo;
  selectedStorefrontBranches: Array<any> = [];
  modifierOptionsMap: { [key: number]: any[] } = {};
  selectedOptionsLength: number[] = [];
  addNewCategoryTitle: string = i18n.product.add_category; 
  pondOptions = {
    multiple: false,
    // allowRevert: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    imagePreviewMarkupShow: false,
    imageResizeMode: 'cover',
    // labelIdle: `
    // <div style="text-align: center;">
    // 	<p>${i18n.drag_and_drop_file}</p>
    // </div>`,
    imageResizeTargetWidth: 170,
    imagePreviewMinHeight: 200,
    imagePreviewHeight: 200,
    imagePreviewMaxHeight: 200,
    imageResizeTargetHeight: 200,
    // server: this.uploadToServer,
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`,
    maxFileSize: '500KB',
    beforeRemoveFile: this.pondHandleRemoveFile,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private productService: ProductService,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private modifierService: ModifierService
  ) {
  }

  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
    this.productForm = this.fb.group(new ProductForm(new Product(this.productInfo)));

    if (this.productInfo.product_image)
      this.productImageUrl = this.productInfo.product_image;

    const prepTime = this.productInfo.preparation_time;
    
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 1000);

    this.loadModifiers()


    this.selectedStorefrontBranches = this.productInfo.inactive_branches;

  }

  pondHandleInit() {
    // console.log('FilePond has initialised', this.myPond);
  }

  onLOgoDelete(event: any) {
    this.deleteLogo = true;
  }

  pondHandleAddFile(event: any) {
    console.log('File added', event.file);
    this.base64LogoString = [];
    this.deleteLogo = false;

    const file = event.file.file;

    if (file && file?.size <= 512000) {
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  handleReaderLoaded(e) {
    this.base64LogoString.push('data:image/png;base64,' + btoa(e.target.result));
  }

  async pondHandleRemoveFile(event: any) {
    let confirm = await Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.setting.you_want_to_delete_logo,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    })
    if (confirm.isConfirmed) {
      return true
    }
    return false;
  }

  get f() {
    return this.productForm.controls;
  }

  get amount() {
    let price = this.productForm.controls.price.value;
    let discount = this.productForm.controls.discount_percent.value;

    if (discount)
      return price - (price * discount / 100);

    return price;
  }

  submit() {
    this.isSubmitted = true;
    if (this.productForm.valid) {
      return new Promise((resolve, reject) => {
        this.loaderService.startLoading();
        let fd: any = this.productForm.value;
        fd.uuid = this.productInfo.uuid;

        if (this.base64LogoString != null) {
          fd.product_image = this.base64LogoString[0];
        }

        if (this.deleteLogo == true) {
          fd.delete_product_image = true;
          fd.product_image = null;
        }

        this.productService.update(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe((res) => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.done, i18n.product.updated, 'success');
          this.activeModal.close(res);
          resolve(res);
        }, (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.productForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
        this.isSubmitted = false;
      })
    } else {
      console.log('Form is invalid:', this.productForm.errors); // logs form-level errors
      console.log('All control errors:', this.getFormValidationErrors());
    }
  }

  // Getter for addons FormArray
  get addons(): FormArray {
    return this.productForm.get('add_ons') as FormArray;
  }

  getAddonsFormGroup(index) {
    return this.addons.controls[index] as FormGroup;
  }

  getFormValidationErrors() {
    const errors: any = {};
    Object.keys(this.productForm.controls).forEach(key => {
      const controlErrors = this.productForm.get(key)?.errors;
      if (controlErrors) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  // Add new addon
  // addAddon() {
  //   const addonGroup = this.fb.group(new ProductAddonForm(new ProductAddon()))
  //   this.addons.push(addonGroup);
  // }
  addAddon() {
    const index = this.addons.length;

    const addonGroup = this.fb.group({
      modifier_id: [null, Validators.required],
      min: [0],
      max: [0],
      modifier_option_id: [[], [
        notAllOptionsSelectedValidator(() => this.modifierOptionsMap[index])
      ]]
    });

    addonGroup.get('modifier_id')?.valueChanges.subscribe((modifierId) => {
      this.applyModifierValidators(addonGroup, modifierId, index)
    });

    this.addons.push(addonGroup);
  }

  applyModifierValidators(addonGroup: AbstractControl, modifierId: number, index: number) {
    const selectedModifier = this.modifiers.find(m => m.id == modifierId);

    if (selectedModifier) {
      const minCtrl = addonGroup.get('min');
      const maxCtrl = addonGroup.get('max');
      const modifierOptionIdCtrl = addonGroup.get('modifier_option_id');

      minCtrl?.setValidators([
        Validators.required,
        Validators.min(0),
        Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
      ]);

      maxCtrl?.setValidators([
        Validators.required,
        Validators.min(0),
        Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
      ]);

      modifierOptionIdCtrl?.setValidators([
        notAllOptionsSelectedValidator(() => this.modifierOptionsMap[index])
      ]);

      // if (!maxCtrl?.value) {
      //   maxCtrl?.setValue(selectedModifier.maxLimit-this.selectedOptionsLength[index]);
      // }
      this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];
      console.log(this.modifierOptionsMap[index]);
      addonGroup.setValidators(minMaxValidator);

      minCtrl?.updateValueAndValidity();
      maxCtrl?.updateValueAndValidity();
      modifierOptionIdCtrl?.updateValueAndValidity();
      addonGroup.updateValueAndValidity();
    }
  }

  loadModifiers() {
    this.modifierService.getModifiers().subscribe(data => {
      this.modifiers = data;
      setTimeout(() => {
        const addons = this.productForm.get('add_ons') as FormArray;
        let index = 0;
        addons.controls.forEach((addonGroup: AbstractControl) => {
          const modifierId = addonGroup.get('modifier_id')?.value;
          if (modifierId) {
            this.applyModifierValidators(addonGroup, modifierId, index)
            index++;
          }
        })
      }, 1000);
    });
  }

  // Remove an addon by index
  removeAddon(index: number) {
    this.addons.removeAt(index);
  }

  loadProduct(product: Product) {
    const addonArray = this.fb.array([]);

    product.add_ons.forEach((addon: ProductAddon) => {
      addonArray.push(this.fb.group(new ProductAddonForm(addon)));
    });

    this.productForm = this.fb.group({
      add_ons: addonArray
    });
  }

  getAvailableModifiers(currentIndex: number): Modifier[] {
    if (!Array.isArray(this.modifiers)) return [];

    const selectedIds = this.addons.controls
      .map((ctrl, idx) => {
        if (idx !== currentIndex) {
          const value = ctrl.get('modifier_id')?.value;
          return this.toSafeNumber(value);
        }
      })
      .filter((id): id is number => id !== null);

    return this.modifiers.filter(mod => !selectedIds.includes(mod.id));
  }

  toSafeNumber(value, fallback = 0) {
    const num = Number(value);
    return isNaN(num) ? fallback : num;
  }

  isNotBranchAndFoodics() {
    return this.basicInfo?.is_branch && !this.basicInfo?.market_place;
  }

  receiveArray(data: string[], index: number) {
    this.selectedOptionsLength[index] = data.length;
    setTimeout(() => {
      const addons = this.productForm.get('add_ons') as FormArray;
      let index = 0;
      addons.controls.forEach((addonGroup: AbstractControl) => {
        const modifierId = addonGroup.get('modifier_id')?.value;
        if (modifierId) {
          const selectedModifier = this.modifiers.find(m => m.id == modifierId);

          if (selectedModifier) {
            this.modifierOptionsMap[index] = selectedModifier.modifier_options || [];
            const minCtrl = addonGroup.get('min');
            const maxCtrl = addonGroup.get('max');

            minCtrl?.setValidators([
              Validators.required,
              Validators.min(0),
              Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
            ]);

            maxCtrl?.setValidators([
              Validators.required,
              Validators.min(0),
              Validators.max(selectedModifier.maxLimit-this.selectedOptionsLength[index])
            ]);
            addonGroup.setValidators(minMaxValidator);
            minCtrl?.updateValueAndValidity();
            maxCtrl?.updateValueAndValidity();
          }
          index++;
        }
      })
    }, 200);
  }

  onChangeClient(value: any) {
    if (value) {
      if (value.id == '__add_new_items__') {
        this.select2Directive.clear();
        const modalRef = this.modalService.open(AddCategoryModalComponent);

        // Set id on modal dialog
        // modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newCategory";
        modalRef.componentInstance.type = 'product';
        modalRef.result.then(result => {
          this.productInfo.category_id = result.id;
          this.productInfo.category = result.name;
          this.productForm.get('category_id').setValue(result.id)
        });
      } else {
        this.productInfo.category_id = value.id;
      }
    }
  }
}
